/**
 * Denormalizes coordinates from 0-1 range back to pixel values
 * @param {Object} point - Normalized point {x, y}
 * @param {number} width - Canvas width
 * @param {number} height - Canvas height
 * @returns {Object} Denormalized point {x, y}
 */
export const denormalizeXY = ({ x, y }, width, height) => {
  return {
    x: x * width,
    y: y * height
  };
};